import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'

export const POPUP_DIRECTIONS = [
  Directions.BOTTOM_RIGHT,
  Directions.BOTTOM_LEFT,
  Directions.TOP_RIGHT,
  Directions.TOP_LEFT,
  Directions.BOTTOM_CENTER,
  Directions.TOP_CENTER,
]

export const VISIBLE_CHANGES = 10
